import React, { useEffect, useState } from "react";
import { LiaEditSolid } from "react-icons/lia";
import styles from "./profile.module.css";
import { get, post } from "../../../components/api";
import { Button, Form, Modal } from "react-bootstrap";

const ProfileCompany = () => {
  const [profileData, setProfileData] = useState({
    name: "",
    mobileNo: "",
    email: "",
    address: "",
  });
  const [formData, setFormData] = useState({
    name: "",
    position: "",
    companyName: "",
    email: "",
    mobileNo: "",
    address: "",
  });
  const [show, setShow] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);

  const handleImageClick = (imgUrl) => {
    setPreviewImage(imgUrl);
    setShowImageModal(true);
  };

  const handleImageModalClose = () => {
    setShowImageModal(false);
    setPreviewImage("");
  };
  const fetchProfileData = async () => {
    const response = await get(
      "/company/Load_profile/edit/6788dc0ae06b47d6396906ff"
    );

    if (response.status == 200) {
      setProfileData(response.data);
      setFormData({
        name: response.data.name,
        position: "",
        companyName: response.data.companyName,
        email: response.data.email,
        mobileNo: response.data.mobileNo,
        address: response.data.address,
      });
    } else {
      setProfileData({ name: "", mobileNo: "", email: "", address: "" });
    }
  };
  useEffect(() => {
    fetchProfileData();
  }, []);
  const handleEdit = () => {
    setShow(true);
  };
  const handleClose = () => {
    setFormData({
      name: "",
      position: "",
      companyName: "",
      email: "",
      mobileNo: "",
      address: "",
    });
    setShow(false);
  };
  const hadnleSubmit = async () => {
    const response = await post("company/Load_profile/edit_profile", formData);
    if (response.status == 200) {
      setProfileData(response.data);
      setShow(false);
      setFormData({
        name: response.data?.name,
        position: "",
        companyName: response.data?.companyName,
        email: response.data?.email,
        mobileNo: response.data?.mobileNo,
        address: response.data?.address,
      });
    } else {
      setShow(false);
      setFormData({
        name: profileData?.name,
        position: "",
        companyName: profileData?.companyName,
        email: profileData?.email,
        mobileNo: profileData?.mobileNo,
        address: profileData?.address,
      });
    }
  };
  return (
    <>
      <div className={styles.profile}>
        <div className={styles.Heading}>
          <p>My Profile</p>
        </div>
        <div className={styles.MainCard}>
          <div className={styles.FirstDiv}>
            <div className={styles.FirstDiv1}>
              <div className={styles.ProfileImageDiv}>
                {" "}
                <img
                  src="https://s3-alpha-sig.figma.com/img/0a60/2678/fd7286b4436391a35c0a6f7dbe0de2ae?Expires=1743379200&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=nbY6462Dgj2m-1y4Ag5er7y6r4wn4wHUAolV4yM4MkEzYxFbJgSF-Mx7yyOUsuwdVFFGvNrbs1-JrvlAkZihZbS-UW6gSp~zVbIgVebJ58EgpNDF65vjELdsLhstCGHXZZcAq12zPSMGoeK9R8KfCt~gfdbvpSntVETSP870zLXbD7kHyCHY8bJBbIwfENIbTnhv25IfcA~RRKublpGd9S70wXNxigQgqHMavurt3iNIWsmuT1ltALLgtfJZKnund4y5T7ZDyvTNZJji7Fti254WsafFqSb1r0m9VjNPPN82gvzceGv7gRCPlB~7mEd-2j7-sd4P9jey64CdM6NkgA__"
                  alt="profile_photo"
                />
              </div>
              <div className={styles.ProfileInfoDiv}>
                <p className={styles.MainText}>{profileData.name}</p>
                <p className={styles.secondaryText}>Owner</p>
                <p className={styles.secondaryText}>Cloudstakes Technology</p>
              </div>
            </div>
            <div className={styles.FirstDiv2}>
              <button className={styles.editButton} onClick={handleEdit}>
                Edit
                <LiaEditSolid size={18} />
              </button>
              <Modal
                show={show}
                onHide={handleClose}
                centered
                dialogClassName={styles.custom_modal_position}
              >
                <Modal.Header closeButton>
                  <Modal.Title className={styles.modalHeader}>
                    Edit My Profile
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form>
                    <Form.Group className="mb-2">
                      <Form.Label className={styles.FormLabel}>
                        Full Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={formData.name}
                        onChange={(e) =>
                          setFormData({ ...formData, name: e.target.value })
                        }
                        placeholder="Enter your full name"
                        className={styles.FormInput}
                      />
                    </Form.Group>
                    <Form.Group className="mb-2">
                      <Form.Label className={styles.FormLabel}>
                        Company Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={formData.companyName}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            companyName: e.target.value,
                          })
                        }
                        placeholder="Enter your company name"
                        className={styles.FormInput}
                      />
                    </Form.Group>
                    <Form.Group className="mb-2">
                      <Form.Label className={styles.FormLabel}>
                        Email Address
                      </Form.Label>
                      <Form.Control
                        type="email"
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                        placeholder="Enter your email"
                        className={styles.FormInput}
                      />
                    </Form.Group>
                    <Form.Group className="mb-2">
                      <Form.Label className={styles.FormLabel}>
                        Phone Number
                      </Form.Label>
                      <Form.Control
                        type="tel"
                        value={formData.mobileNo}
                        onChange={(e) =>
                          setFormData({ ...formData, mobileNo: e.target.value })
                        }
                        placeholder="Enter your phone number"
                        className={styles.FormInput}
                      />
                    </Form.Group>
                    <Form.Group className="mb-2">
                      <Form.Label className={styles.FormLabel}>
                        Full Address
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={formData.address}
                        onChange={(e) =>
                          setFormData({ ...formData, address: e.target.value })
                        }
                        placeholder="Enter your address"
                        className={styles.FormInput}
                      />
                    </Form.Group>
                  </Form>
                </Modal.Body>
                <Modal.Footer className={styles.footer}>
                  <Button className={styles.cancleButton} onClick={handleClose}>
                    Cancel
                  </Button>
                  <Button
                    className={styles.submitButton}
                    onClick={hadnleSubmit}
                  >
                    Update
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
          <div className={styles.SecondDiv}>
            <div>
              <p className={styles.secondaryText}>Email Address</p>
              <p className={styles.MainText}>{profileData.email}</p>
            </div>
            <div>
              <p className={styles.secondaryText}>Phone</p>
              <p className={styles.MainText}>{profileData.mobileNo}</p>
            </div>
          </div>
          <div className={styles.ThirdDiv}>
            <div>
              <p className={styles.secondaryText}>Address</p>
              <p className={styles.MainText}>{profileData.address}</p>
            </div>
          </div>
          <div className={styles.FourthDiv}>
            <p className={styles.MainText}>
              KYC{"     "}
              <svg
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 1.78723L6.72352 0L13.4468 1.78723V9.44676C12.4115 12.9574 10.0286 14.9859 6.72352 16C3.41846 14.9859 1.03537 12.9574 0 9.44676V1.78723ZM2.13199 8.28062L3.33551 7.0771L5.54372 9.84277L10.1117 3.75042L11.3152 4.95416L5.5439 12.2496L2.13199 8.28062Z"
                  fill="#21CB49"
                />
              </svg>
            </p>
            <div className={styles.kYCDiv}>
              <div
                className={styles.ImageDiv}
                onClick={() =>
                  handleImageClick(
                    "https://i.pinimg.com/736x/1c/fb/4e/1cfb4eca9083a70e4d0a60963bb729d9.jpg"
                  )
                }
              >
                <img
                  src="https://i.pinimg.com/736x/1c/fb/4e/1cfb4eca9083a70e4d0a60963bb729d9.jpg"
                  alt="aadharcard"
                />
                <p className={styles.ImageTitle}>Aadhar Card</p>
              </div>
              <div
                className={styles.ImageDiv}
                onClick={() =>
                  handleImageClick(
                    "https://i.pinimg.com/736x/1c/fb/4e/1cfb4eca9083a70e4d0a60963bb729d9.jpg"
                  )
                }
              >
                <img
                  src="https://i.pinimg.com/736x/1c/fb/4e/1cfb4eca9083a70e4d0a60963bb729d9.jpg"
                  alt="aadharcard"
                />
                <p className={styles.ImageTitle}>Pan Card</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showImageModal}
        onHide={handleImageModalClose}
        centered
        size="lg"
      >
        <Modal.Body className="p-0">
          <img
            src={previewImage}
            alt="preview"
            style={{ width: "100%", height: "auto" }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProfileCompany;
